import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './authorized-data/home/index';
import { LoginComponent } from './login/index';
import { HomeSerachComponent } from './home-serach/home-serach.component';
import { AuthGuard } from './_guards/index';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SignupComponent } from './signup/signup.component';
import { PostMusicComponent } from './authorized-data/post-music-listing/post-music/post-music.component';
import { PostMusicEditComponent } from './authorized-data/post-music-listing/post-music-edit/post-music-edit.component';
import { PostBookComponent } from './authorized-data/post-book-listing/post-book/post-book.component';
import { PostGraphicsComponent } from './authorized-data/post-graphics-listing/post-graphics/post-graphics.component';
import { PostServicesComponent } from './authorized-data/post-services-listing/post-services/post-services.component';
import { PostStuffComponent } from './authorized-data/post-stuff-listing/post-stuff/post-stuff.component';
import { PostVideosComponent } from './authorized-data/post-videos-listing/post-videos/post-videos.component';
import { PostMusicListingComponent } from './authorized-data/post-music-listing/post-music-listing.component';
import { TermconditionComponent } from './pages/termcondition/termcondition.component';
import { PostingrulesComponent } from './pages/postingrules/postingrules.component';
import { PostAllComponent } from './authorized-data/post-music-listing/post-all/post-all.component';
import { PostBookListingComponent } from './authorized-data/post-book-listing/post-book-listing.component';
import { PostBookHomeComponent } from './authorized-data/post-book-listing/post-book-home/post-book-home.component';
import { PostGraphicsListingComponent } from './authorized-data/post-graphics-listing/post-graphics-listing.component';
import { PostGraphicsHomeComponent } from './authorized-data/post-graphics-listing/post-graphics-home/post-graphics-home.component';
import { PostServicesHomeComponent } from './authorized-data/post-services-listing/post-services-home/post-services-home.component';
import { PostServicesListingComponent } from './authorized-data/post-services-listing/post-services-listing.component';
import { PostStuffListingComponent } from './authorized-data/post-stuff-listing/post-stuff-listing.component';
import { PostStuffHomeComponent } from './authorized-data/post-stuff-listing/post-stuff-home/post-stuff-home.component';
import { PostVideosListingComponent } from './authorized-data/post-videos-listing/post-videos-listing.component';
import { PostVideoHomeComponent } from './authorized-data/post-videos-listing/post-video-home/post-video-home.component';
import { DetailItemComponent } from './authorized-data/detail-item/detail-item.component';
import { SellerInfoComponent } from './authorized-data/seller-info/seller-info.component';
import { SendRequestComponent } from './authorized-data/send-request/send-request.component';
import { ReceiveRequestComponent } from './authorized-data/receive-request/receive-request.component';
import { BidAcceptComponent } from './authorized-data/bid-accept/bid-accept.component';
import { PendingPurchaseComponent } from './authorized-data/pending-purchase/pending-purchase.component';
import { ItemHistoryComponent } from './authorized-data/item-history-sold/item-history.component';
import { ItemHistoryBoughtComponent } from './authorized-data/item-history-bought/item-history-bought.component';
import { NotificationComponent } from './authorized-data/notification/notification.component';
import { PostBookEditComponent } from './authorized-data/post-book-listing/post-book-edit/post-book-edit.component';
import { PostGraphicsEditComponent } from './authorized-data/post-graphics-listing/post-graphics-edit/post-graphics-edit.component';
import { PostServicesEditComponent } from './authorized-data/post-services-listing/post-services-edit/post-services-edit.component';
import { PostStuffEditComponent } from './authorized-data/post-stuff-listing/post-stuff-edit/post-stuff-edit.component';
import { PostVideosEditComponent } from './authorized-data/post-videos-listing/post-videos-edit/post-videos-edit.component';
import { ServiceProviderListComponent } from './authorized-data/post-services-listing/service-provider-list/service-provider-list.component';
import { ServicePaymentComponent } from './authorized-data/service-payment/service-payment.component';
import { BidItemUpdateComponent } from './authorized-data/bid-item-update/bid-item-update.component';
import { ServicePaymentRequestComponent } from './authorized-data/service-payment-request/service-payment-request.component';
import { UserComponent } from './authorized-data/user/user.component';
import { UserProfileComponent } from './authorized-data/user/user-profile/user-profile.component';
import { UserProfileEditComponent } from './authorized-data/user/user-profile-edit/user-profile-edit.component';
import { RadioListComponent } from './authorized-data/radio-list/radio-list.component';
import { ProfileComponent } from './profile/profile.component';
import { HelpInfoComponent } from './pages/help-info/help-info.component';
import { ChatComponent } from './authorized-data/chat/chat.component';
import { ServiceRequestsComponent } from './authorized-data/service-requests/service-requests.component';
import { ChangePasswordComponent } from './authorized-data/user/change-password/change-password.component';
import { SearchAlertsComponent } from './authorized-data/search-alerts/search-alerts.component';
import { TradeHomeComponent } from './authorized-data/trade/trade-home/trade-home.component';
import { TradeAddComponent } from './authorized-data/trade/trade-add/trade-add.component';
import { TradeEditComponent } from './authorized-data/trade/trade-edit/trade-edit.component';
import { TradeRequestSentComponent } from './authorized-data/trade/trade-request-sent/trade-request-sent.component';
import { TradeRequestRecievedComponent } from './authorized-data/trade/trade-request-recieved/trade-request-recieved.component';
import { TradeDetailComponent } from './authorized-data/trade/trade-detail/trade-detail.component';
import { MyTradeComponent } from './authorized-data/trade/my-trade/my-trade.component';
import { TradeChatComponent } from './authorized-data/trade/trade-chat/trade-chat.component';
import { TradeHistoryComponent } from './authorized-data/trade/trade-history/trade-history.component';
import { TradAlertComponent } from './authorized-data/trade/trad-alert/trad-alert.component';
import { TermsConditionsComponent } from './authorized-data/terms-conditions/terms-conditions.component';
import { StripeInformationComponent } from './stripe-information/stripe-information.component';
import { FreeHomeComponent } from './authorized-data/free/free-home/free-home.component';
import { MyFreeComponent } from './authorized-data/free/my-free/my-free.component';
import { FreeAddComponent } from './authorized-data/free/free-add/free-add.component';
import { FreeEditComponent } from './authorized-data/free/free-edit/free-edit.component';
import { FreeChatComponent } from './authorized-data/free/free-chat/free-chat.component';
import { FreeRequestSentComponent } from './authorized-data/free/free-request-sent/free-request-sent.component';
import { FreeDetailComponent } from './authorized-data/free/free-detail/free-detail.component';
import { FreeDetailItemComponent } from './authorized-data/free-detail-item/free-detail-item.component';
import { FreeRequestRecievedComponent } from './authorized-data/free/free-request-recieved/free-request-recieved.component';
import { FreeAlertComponent } from './authorized-data/free/free-alert/free-alert.component';
import { FreeHistoryComponent } from './authorized-data/free/free-history/free-history.component';
import { FreeRequestDetailComponent } from './authorized-data/free/free-request-detail/free-request-detail.component';
import { FreeHistoryDetailComponent } from './authorized-data/free/free-history-detail/free-history-detail.component';
import { ChatServiceComponent } from './authorized-data/chat-service/chat-service.component';
import { PrivacyConditionsComponent } from './authorized-data/privacy-conditions/privacy-conditions.component';


const appRoutes: Routes = [
  { path: '', component: HomeSerachComponent },
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeSerachComponent },
  { path: 'register', component: SignupComponent },
  { path: 'home', component: HomeSerachComponent },
  { path: 'forget-password', component: ForgotPasswordComponent },
  { path: 'test', component: SignupComponent },
  { path: 'stripe-information', component: StripeInformationComponent },
  { path: 'terms-conditions', component: TermsConditionsComponent },
  { path: 'privacy-conditions', component: PrivacyConditionsComponent },


  { path: 'dashboard', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'notification', component: NotificationComponent, canActivate: [AuthGuard] },
  { path: 'item/detail-item/:id', component: DetailItemComponent, canActivate: [AuthGuard] },
  { path: 'seller-info/:sellerid/:type', component: SellerInfoComponent, canActivate: [AuthGuard] },
  { path: 'send-request', component: SendRequestComponent, canActivate: [AuthGuard] },
  { path: 'receive-request', component: ReceiveRequestComponent, canActivate: [AuthGuard] },
  { path: 'bid-accept/:buyerid/:item_id', component: BidAcceptComponent, canActivate: [AuthGuard] },
  { path: 'purchase', component: PendingPurchaseComponent, canActivate: [AuthGuard] },
  { path: 'item-sold', component: ItemHistoryComponent, canActivate: [AuthGuard] },
  { path: 'item-purchase', component: ItemHistoryBoughtComponent, canActivate: [AuthGuard] },
  { path: 'payment-service/:itemId', component: ServicePaymentComponent, canActivate: [AuthGuard] },
  { path: 'bid-item-update/:id', component: BidItemUpdateComponent, canActivate: [AuthGuard] },
  { path: 'request-payment/:itemId', component: ServicePaymentRequestComponent, canActivate: [AuthGuard] },
  { path: 'radio-list', component: RadioListComponent, canActivate: [AuthGuard] },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'help', component: HelpInfoComponent, canActivate: [AuthGuard] },
  { path: 'change-password', component: ChangePasswordComponent, canActivate: [AuthGuard] },

  { path: 'freeitem/detail-item/:id', component: FreeDetailItemComponent, canActivate: [AuthGuard] },


  {
    path: 'myprofile', component: UserComponent, canActivate: [AuthGuard],
    children: [
      { path: '', component: UserProfileComponent },
      // { path: 'change-password', component: ChangePasswordComponent }
    ]
  },
  {
    path: 'music-list', component: PostMusicListingComponent, canActivate: [AuthGuard],
    children: [
      { path: '', component: PostAllComponent },
      { path: 'post-music', component: PostMusicComponent },
      { path: 'music-edit/:itemid', component: PostMusicEditComponent }
    ]
  },
  {
    path: 'book-list', component: PostBookListingComponent, canActivate: [AuthGuard],
    children: [
      { path: '', component: PostBookHomeComponent },
      { path: 'post-book', component: PostBookComponent },
      { path: 'book-edit/:itemid', component: PostBookEditComponent }
    ]
  },
  {
    path: 'graphics-list', component: PostGraphicsListingComponent, canActivate: [AuthGuard],
    children: [
      { path: '', component: PostGraphicsHomeComponent },
      { path: 'post-graphics', component: PostGraphicsComponent },
      { path: 'graphics-edit/:itemid', component: PostGraphicsEditComponent }
    ]
  },
  {
    path: 'services-list', component: PostServicesListingComponent, canActivate: [AuthGuard],
    children: [
      { path: '', component: PostServicesHomeComponent },
      { path: 'post-services', component: PostServicesComponent },
      { path: 'services-edit/:itemid', component: PostServicesEditComponent },
      { path: 'services/:serviceId', component: ServiceProviderListComponent }
    ]
  },
  {
    path: 'stuff-list', component: PostStuffListingComponent, canActivate: [AuthGuard],
    children: [
      { path: '', component: PostStuffHomeComponent },
      { path: 'post-stuff', component: PostStuffComponent },
      { path: 'stuff-edit/:itemid', component: PostStuffEditComponent }
    ]
  },
  {
    path: 'videos-list', component: PostVideosListingComponent, canActivate: [AuthGuard],
    children: [
      { path: '', component: PostVideoHomeComponent },
      { path: 'post-video', component: PostVideosComponent },
      { path: 'videos-edit/:itemid', component: PostVideosEditComponent }
    ]
  },
  { path: 'term-and-conditions', component: TermconditionComponent },
  { path: 'posting-rules', component: PostingrulesComponent },
  { path: 'chat', component: ChatComponent, canActivate: [AuthGuard] },
  { path: 'chat-service', component: ChatServiceComponent },
  { path: 'service-requests', component: ServiceRequestsComponent, canActivate: [AuthGuard] },
  { path: 'search-alerts', component: SearchAlertsComponent, canActivate: [AuthGuard] },
  { path: 'trade', component: TradeHomeComponent, canActivate: [AuthGuard] },
  { path: 'trade/trade-add/:type/:itemid', component: TradeAddComponent, canActivate: [AuthGuard] },
  { path: 'trade/trade-edit/:itemid', component: TradeEditComponent, canActivate: [AuthGuard] },
  { path: 'trade/sent', component: TradeRequestSentComponent, canActivate: [AuthGuard] },
  { path: 'trade/recieved', component: TradeRequestRecievedComponent, canActivate: [AuthGuard] },
  { path: 'trade/detail/:id', component: TradeDetailComponent, canActivate: [AuthGuard] },
  { path: 'my-trade', component: MyTradeComponent, canActivate: [AuthGuard] },
  { path: 'trade/chat/:id', component: TradeChatComponent, canActivate: [AuthGuard] },
  { path: 'trade/history', component: TradeHistoryComponent, canActivate: [AuthGuard] },
  { path: 'trade/alert', component: TradAlertComponent, canActivate: [AuthGuard] },
  { path: 'free', component: FreeHomeComponent, canActivate: [AuthGuard] },
  { path: 'my-free', component: MyFreeComponent, canActivate: [AuthGuard] },
  { path: 'free/free-add/:type/:itemid', component: FreeAddComponent, canActivate: [AuthGuard] },
  { path: 'free/free-edit/:itemid', component: FreeEditComponent, canActivate: [AuthGuard] },
  { path: 'free/chat/:id', component: FreeChatComponent, canActivate: [AuthGuard] },
  { path: 'free/sent', component: FreeRequestSentComponent, canActivate: [AuthGuard] },
  { path: 'free/detail/:id', component: FreeDetailComponent, canActivate: [AuthGuard] },
  { path: 'free/recieved', component: FreeRequestRecievedComponent, canActivate: [AuthGuard] },
  { path: 'free/alert', component: FreeAlertComponent, canActivate: [AuthGuard] },
  { path: 'free/history', component: FreeHistoryComponent, canActivate: [AuthGuard] },
  { path: 'free/recived/detail/:id/:idd/:status', component: FreeRequestDetailComponent, canActivate: [AuthGuard] },
  { path: 'free/historydetail/:id', component: FreeHistoryDetailComponent, canActivate: [AuthGuard] },



  { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts